"use client";
import Chart from "@/app/components/Chart";
import InvestingSignals from "@/app/components/InvestingSignals";
import { SOLPrice } from "@/lib/metrics";
import { SolPerfProof } from "@/lib/PerformanceProofSource";
import { Box, Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import CryptoOverviewPanel from "./CryptoOverviewPanel";
import PerformanceProofChart from "./PerfomanceProofChart";
import WalletTablesRow from "./WalletTablesRow";
import UnlockSignalBanner from "./UnlockSignalBanner";

export default function SolPanel() {
  const t = useTranslations();

  return (
    <Box sx={{ flex: 1, pt: 4, px: 3 }}>
      <UnlockSignalBanner />
      <Typography variant="h5" sx={{ mb: 2, fontWeight: "bold" }} id="btc-pulse">
        {t.rich("Analytics.cryptoPulse", { crypto: "SOL" })}
      </Typography>
      <CryptoOverviewPanel crypto="sol" />

      <Box
        sx={{
          display: { xs: "block", md: "flex" },
          mt: 3,
          gap: 1,
          alignItems: "stretch",
        }}>
        <InvestingSignals crypto="sol" />
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", width: { xs: "100%", md: "auto" } }}>
          <Chart metricId={SOLPrice.id} chartHeight="18rem" />
        </Box>
      </Box>
      <Box sx={{ mt: 1 }}>
        <PerformanceProofChart symbol="sol" perfProof={SolPerfProof} chartHeight="27rem" />
      </Box>
      <Box sx={{ mt: 1, mb: 11, minWidth: 0 }}>
        <WalletTablesRow symbol="sol" />
      </Box>
    </Box>
  );
}
